import {
  Component,
  OnInit,
  type ElementRef,
  TemplateRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';
import { SettingsService } from '../../settings/settings.service';
import { Router, ActivatedRoute } from '@angular/router';
import moment from 'moment';
import { CookieService } from 'ngx-cookie-service';


import { MatSnackBar } from '@angular/material/snack-bar';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { LocalStoreService } from 'src/app/shared/services/local-store.service';
import { environment } from 'src/environments/environment';
import { FullLoaderService } from 'src/app/shared/services/full-loader.service';
import { ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
// import { stat } from 'fs';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { BuyerQuoteSWRService, type BuyerQuoteQuery } from './quote-swr.service';

const labelMap: Record<string, string> = {
  name: 'Name',
  address: 'Address',
  contact: 'Contact',
  phone: 'Phone',
  fax: 'Fax',
  email: 'Email',
  billingAddress: 'Billing Address',
  mpsBuyerCode: 'MPS Buyer Code',
  mpsSupplierCode: 'MPS Supplier Code',
  PIC: 'PIC',
  vat: 'VAT'

};

@Component({
  selector: 'app-buyer-quote-list',
  templateUrl: './buyer-quote-list.component.html',
  styleUrls: ['./buyer-quote-list.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BuyerQuoteListComponent {
  @ViewChild('supplierTable') table!: DatatableComponent;

  @ViewChild('archivedSection', { static: false })
  archivedSection!: ElementRef;
  @ViewChild('heading', { static: false })
  heading!: ElementRef;
  menuTrigger: MatMenuTrigger | null = null;
  // supplierData: any[] = [];
  showLoader: boolean = true;
  showDetailLoader: boolean = true;
  nextMpsCode: number = 0;
  searchKeyword: string = '';
  userRole!: string;
  archivedLoaded: boolean = false;
  isBuyer: boolean | undefined;
  limit: number = 10; // Rows per page
  offset: number = 0; // Current page offset
  archivedLimit: number = 10; // Rows per page
  archivedOffset: number = 0; // Current page offset
  totalRecords: number = 0; // Total number of records
  archivedTotalRecords: number = 0;
  sortField: string = 'quotationSubmissionDate';
  sortDirection: string = 'DESC';
  docStatus: any;
  fromDate: any;
  toDate: any;
  operationType: string = 'buyerQuote';
  masterSelected: boolean = false;
  isWrapDescription: boolean = false;
  // allDocumentData: any[] = [];
  documentData: any[] = [];
  AllQuotes: any;
  archivedDocumentData: any[] = [];
  documentDataTotalRecords: number = 0;
  isFilterExpand: boolean = false;
  isArchivedExpand: boolean = false;
  searchParam: string = '';
  selectedRfq: number[] = [];
  selectedQuote: number[] = [];
  selectedRfqDetails: number[] = [];
  selectedQuoteDetails: number[] = [];
  selectedArchivedRfq: number[] = [];
  selectedArchivedQuotes: number[] = [];
  selectedStatus: string = 'ALL';

  quoteTypeDropdownOpen: boolean = false;

  rfqStagesList = [
    { name: 'Unactioned', heading: 'RFQ Sent:' },
    // { name: 'Acknowledged', heading: 'RFQ Acknowledged:' },
    // { name: 'Declined', heading: 'RFQ Declined:' },
    // { name: 'Lost', heading: 'RFQ Lost:' },
    { name: 'Expired', heading: 'RFQ Expired:' },
    // { name: 'Submitted', heading: 'RFQ Submitted:' },
    { name: 'Draft', heading: 'RFQ Drafted:' },
    { name: 'Canceled', heading: 'RFQ Canceled:' },
    { name: 'Created', heading: 'RFQ Created:' },
  ];

  quoteStagesList = [
    { name: 'Accepted', heading: 'Quotation Recieved' },
    { name: 'Declined', heading: 'Quotation Declined:' },
    { name: 'Draft', heading: 'Quotation Drafted:' },
    { name: 'Quoted', heading: 'Quotation Recieved' },
    { name: 'Withdrawn', heading: 'Quote Withdrawn:' },
  ];

  rfqStatuses = [
    'Unactioned',
    'Acknowledged',
    'Quoted',
    'Under Review',
    'Clarification Requested',
    'Approved',
    'Rejected',
    'Awarded',
    'Closed',
    'Open',
    'In Review',
    'Awaiting Supplier Response',
    'Canceled',
    'Draft',
    'Declined',
    'Lost',
    'Created',
  ];
  filterStatuses = [
    { name: 'Accepted', label: 'Quote' },
    { name: 'Pending', label: 'Quote' },
    { name: 'Rejected', label: 'Quote' },
    { name: 'ALL', label: 'Quote' },
  ];
  statusColors: { [key: string]: string } = {
    Accepted: '#1ebd60',
    Pending: '#ff9800',
    Rejected: '#FF0000',
  };

  activeIndex: number = this.filterStatuses.length - 1;
  
  quoteStatuses: any[] = ['Accepted', 'Pending', 'Rejected', 'ALL'];

  private quoteListSub: Subscription | null = null;
  private currentQuoteQueryKey: string | null = null;
  private quoteArchivedSub: Subscription | null = null;
  private currentQuoteArchivedQueryKey: string | null = null;

  supplierUsersList: any[] = [];
  // supplierUserMap: { [key: number]: string } = {};
  selectedUsers: any[] = [];
  useroffset: number = 0;
  userlimit: number = 10;
  isLoading: boolean = false;
  showProductPopUp: boolean = false;

  columns = [
    { name: 'Buyer', prop: 'companyName', visible: true },
    { name: 'Document Type', prop: 'docType', visible: true },
    { name: 'Quote Reference', prop: 'quoteRefNumber', visible: true },

    { name: 'Reference', prop: 'rfqRefNumber', visible: true },
    { name: 'Approved By', prop: 'approvedBy', visible: true },
    { name: 'Status', prop: 'docStatus', visible: true },
    { name: 'Quotation Date', prop: 'quotationDate', visible: true },

    { name: 'Date', prop: 'rfqDate', visible: true },

    { name: 'Quote before date', prop: 'quotedByDate', visible: false },
    { name: 'Vessel', prop: 'vesselName', visible: false },
    { name: 'Port Country', prop: 'portCountry', visible: false },
    { name: 'Port Name', prop: 'portName', visible: false },
    { name: 'Buyer Contact Name', prop: 'contact', visible: false },
    // { name: "Supplier Contact Name", prop: "rfqRefNumber", visible: false },
    // { name: "Total Cost", prop: "approvedBy", visible: false },
    { name: 'Delivery date', prop: 'requestDeliveryDate', visible: false },
    // { name: "Expiry Date", prop: "rfqDate", visible: false },
  ];
  expandedRfqId: number | null = null;
  // Track that we auto-expanded the first row once on initial load
  private autoExpandDone: boolean = false;

  items = [
    {
      label: 'Request Delivery Date',
      prop: 'requestDeliveryDate',
      selected: false,
    },
    { label: 'Vessel ETA', prop: 'vesselEta', selected: false },
    { label: 'Vessel ETD', prop: 'vesselEtd', selected: false },
    { label: 'Quote before date', prop: 'quotedByDate', selected: false },
    { label: 'Owner', prop: 'Owner', selected: false },
  ];

  archivedItems = [
    {
      label: 'Request Delivery Date',
      prop: 'requestDeliveryDate',
      selected: false,
    },

    { label: 'Vessel ETA', prop: 'vesselEta', selected: false },
    { label: 'Vessel ETD', prop: 'vesselEtd', selected: false },
    { label: 'Quote before date', prop: 'quotedByDate', selected: false },
    { label: 'Owner', prop: 'Owner', selected: false },
  ];

  selectedColumns: { label: string; prop: string }[] = [];
  archivedSelectedColumns: { label: string; prop: string }[] = [];

  labelFromRFQ: string = '';

  optionsWithRowDetail = {};
  dataWithRowDetail = [];
  @ViewChild('rowDetailTpl', { static: true }) rowDetailTpl:
    | TemplateRef<any>
    | undefined;
  quoteLineItemData: any[] = [];
  showProductReqCost: boolean = false;
  showQuoteReqCost: boolean = false;

  isChatOpen: boolean = false;
  headerData: any;
  userId!: number;


  
  previewSection = false;
  previewDocs: string[] = [];


  showContactPopup:boolean = false;
  selectedSupplier: any = {
    companyName: 'N/A',
    contactPerson: 'N/A',
    email: 'N/A',
    phone: 'N/A',
    address: 'N/A',
    fax:'N/A'

  };

  constructor(
    private SettingsService: SettingsService,
    private router: Router,
    private cookieService: CookieService,
    private snack: MatSnackBar,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    private ls: LocalStoreService,
    private fullLoaderService: FullLoaderService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private quoteSWR: BuyerQuoteSWRService,
    private http: HttpClient,
  ) {
    iconRegistry.addSvgIcon(
      'downloadExcel',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        `${environment.assetsLink}images/excel.svg`
      )
    );
    // this.sanitizer.bypassSecurityTrustResourceUrl(`https://mps-cdn-  }
  }

  async ngOnInit() {

    this.userId = Number(this.cookieService.get('userId'));
    this.userRole = this.cookieService.get('userRole');

    const queryParams = this.route.snapshot.queryParamMap;
    console.log('query params', queryParams);

    this.route.queryParams.subscribe((params) => {
      const statusParam = params['selectedStatus'];
      const labelParam = params['label'];
      console.log('statusParam', statusParam);
      console.log('labelParam', labelParam);

      if (statusParam && labelParam) {
        //  When params are present, use them
        this.selectedStatus = statusParam;
        this.labelFromRFQ = labelParam;
        this.docStatus = statusParam;
        this.setActiveStatus(statusParam, labelParam);
      } else {
        //  Fallback when params are NOT provided
        this.docStatus = 'ALL';
        this.selectedStatus = 'ALL';
      }

      // Auto-populate search from notification redirect
      const refParam = params['ref'];
      if (refParam) {
        this.searchParam = refParam;
      }
    });

    this.userRole = this.cookieService.get('userRole');
    if (this.userRole == 'Owner') {
      this.isBuyer = true;
    }
    this.optionsWithRowDetail = {
      checkboxes: true,
      rowDetailTemplate: this.rowDetailTpl,
    };

    // If ref param is present, search directly instead of fetching all
    const refFromUrl = this.route.snapshot.queryParams['ref'];
    if (refFromUrl) {
      this.searchParam = refFromUrl;
      this.docStatus = 'ALL';
      this.selectedStatus = 'ALL';
    }
    await this.fetchAllDocuments();
   // await this.fetchArchivedAllDocuments();
   // await this.fetchUsers();
  }

  private invalidateActiveListCache() {
    const uid = Number(this.cookieService.get('userId'));
    this.quoteSWR.invalidateMatching(
      (k) => k.startsWith('buyer-quote:') && k.includes('"activeFlag":1') && k.includes(`"userId":${uid}`)
    );
  }

  private invalidateArchivedListCache() {
    const uid = Number(this.cookieService.get('userId'));
    this.quoteSWR.invalidateMatching(
      (k) => k.startsWith('buyer-quote:') && k.includes('"activeFlag":0') && k.includes(`"userId":${uid}`)
    );
  }

  private buildQuoteQuery(activeFlag: 0 | 1): BuyerQuoteQuery {
    const fromDate = this.fromDate
      ? moment(this.fromDate).format('YYYY-MM-DDTHH:mm:ss') + 'Z'
      : null;
    const toDate = this.toDate
      ? moment(this.toDate).format('YYYY-MM-DDTHH:mm:ss') + 'Z'
      : null;
    return {
      searchParam: this.searchParam,
      userId: Number(this.cookieService.get('userId')),
      docStatus: this.docStatus,
      fromDate,
      toDate,
      sortField: this.sortField,
      sortDirection: this.sortDirection as any,
      limit: activeFlag === 1 ? this.limit : this.archivedLimit,
      offset: activeFlag === 1 ? this.offset : this.archivedOffset,
      activeFlag,
      operationType: 'buyerQuote',
    };
  }

  getHeadingFromLabel(label: string, entityType: 'RFQ' | 'Quote'): string {
    const list =
      entityType === 'RFQ' ? this.rfqStagesList : this.quoteStagesList;
    const match = list.find(
      (stage) => stage.name.toLowerCase() === label.toLowerCase()
    );
    return match ? match.heading : label;
  }

  isRfqLapsed(quotedByDate: string | Date): boolean {
    return new Date() > new Date(quotedByDate);
  }

  isRFQExpired(quotedByDate: string | Date): boolean {
    if (!quotedByDate) return false;
    console.log('quotedByDate', quotedByDate)
    console.log('new Date(quotedByDate)', new Date(quotedByDate))
    return new Date() > new Date(quotedByDate);
  }

  formatDate(date: string | Date): string {
    return new Date(date).toLocaleDateString('en-GB');
  }

  setActiveStatus(status: string, label: string) {
    const index = this.filterStatuses.findIndex(
      (s) => s.name === status && s.label === label
    );
    if (index !== -1) {
      this.activeIndex = index;
      this.selectedStatus = status;
      this.docStatus = status;
    } else {
      //  If not found, still default to ALL
      this.docStatus = 'ALL';
      this.selectedStatus = 'ALL';
    }
  }

  async toggleUserSelection(item: any) {
    // console.log("item",item);
    // console.log("this.selectedRfq",this.selectedRfq);
    // Check if any RFQs are selected
    if (this.selectedRfq.length === 0) {
      // If no RFQs are selected, show a snackbar message and return
      this.snack.open(
        'Please select at least one Quote before selecting a user.',
        'OK',
        {
          duration: 3000,
        }
      );
      return;
    }

    // Check if the user is already selected
    item.selected = !item.selected; // Toggle selection for the user

    // If the user is selected, call the API to assign the supplier-user to the RFQ
    if (item.selected) {
      try {
        // Call the SettingsService to assign the user
        this.fullLoaderService.showLoader('Assigning user...');
        const response = await this.SettingsService.assignQuoteToSupplierUser(
          this.selectedRfq,
          Number(this.cookieService.get('userId')),
          item.id
        );
        // const result= await this.SettingsService.fetchSupplierUserByRfqId(this.selectedRfq[0]);
        // console.log({result});
        this.invalidateActiveListCache();
        await this.fetchAllDocuments();
        this.selectedRfq = [];
        item.selected = false;

        this.snack.open('User assigned to Quote successfully.', 'OK', {
          duration: 3000,
        });
        this.fullLoaderService.hideLoader();
      } catch (error) {
        // If the API call fails, handle the error here
        this.snack.open('Failed to assign user to Quote.', 'OK', {
          duration: 3000,
        });
        throw error; // Re-throw the error to be caught in the calling method
      }
    }
  }

  // Method to get status color based on the status
  getStatusColor(status: string): string {
    return this.statusColors[status] || '#000000'; // Default to black if no match
  }

  formatRfqDate(rfqDate: any): string {
    const now = moment(); // Get current time
    const diffInSeconds = now.diff(moment(rfqDate), 'seconds');
    const diffInMinutes = now.diff(moment(rfqDate), 'minutes');
    const diffInHours = now.diff(moment(rfqDate), 'hours');
    const diffInDays = now.diff(moment(rfqDate), 'days');

    // Handle the difference based on time
    if (diffInSeconds < 60) {
      return `${diffInSeconds} seconds ago`;
    } else if (diffInMinutes < 60) {
      return `${diffInMinutes} minutes ago`;
    } else if (diffInHours < 24) {
      return `${diffInHours} hours ago`;
    } else if (diffInDays === 1) {
      return 'Yesterday';
    } else {
      return moment(rfqDate).format('DD MMM YYYY'); // Show date with month and year
    }
  }

  async fetchAllQuotes() {
    try {
      this.operationType = 'exportAll';
      console.log('During export hit docStatus->', this.docStatus);
      const response = await this.SettingsService.fetchAllQuotesByBuyerId(
        this.searchParam,
        Number(this.cookieService.get('userId')),
        this.docStatus,
        null,
        null,
        '',
        '',
        0,
        0,
        1,
        this.operationType
      );
      // console.log('Response from exportAllServicesByAdmin:', response);
      if (response && Array.isArray(response.rows)) {
        this.AllQuotes = response.rows;
      } else {
        console.error('Invalid response structure', response);
      }

      // console.log('Fetched All Quotes Data:', this.AllQuotes);
    } catch (error) {
      console.error('Error fetching all Quotes:', error);
      throw error; // Rethrow the error to be handled by the caller
    }
  }

  async exportAllQuotes() {
    try {
      this.fullLoaderService.showLoader('Exporting Quote Details...');

      await this.fetchAllQuotes();

      if (!this.AllQuotes || this.AllQuotes.length === 0) {
        alert('No Quotes available to export.');
        return;
      }
      console.log('All Quotes Data:', this.AllQuotes);

      const exportData: any[] = [];

      this.AllQuotes.forEach((quotes: any, index: number) => {
        const flattenedProduct = {
          'Sr. No.': index + 1,
          'Quote Reference': quotes.quoteRefNumber || '',
          'RFQ Reference': quotes.rfqRefNumber || '',
          'Port Name': quotes.portName || '',
          'Vessel Name': quotes.vesselName || '',
          Buyer: quotes.companyName || '',
          Status: this.quoteStatuses[quotes.quoteStatus - 1] || '',
          'Quote Submission Date': quotes.quotationDate || '',
          'Request For Delivery Date': quotes.requestDeliveryDate || '',
          'Quote Before Date': quotes.quotedByDate || '',
          'Vessel ETA': quotes.vesselEta || '',
          'Vessel ETD': quotes.vesselEtd || '',
          'Price Good Until': quotes.priceGoodUntil || '',
          'Payment Terms': quotes.paymentTermsAndConditions || '',
          'Total Price': quotes.totalPrice || '',
        };

        exportData.push(flattenedProduct);
      });

      const today = new Date();
      const formattedDate = `${String(today.getDate()).padStart(
        2,
        '0'
      )}-${String(today.getMonth() + 1).padStart(
        2,
        '0'
      )}-${today.getFullYear()}`;
      const fileName = `Supplier_Quotation_List_${formattedDate}.xlsx`;

      // Use XLSX to export data (dynamically loaded)
      const XLSX = await import('xlsx');
      const ws = XLSX.utils.json_to_sheet(exportData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Quotes');
      XLSX.writeFile(wb, fileName);

      this.snack.open('Quotes data exported successfully!', 'OK', {
        duration: 5000,
      });
    } catch (error) {
      console.error('Error while exporting Quotes:', error);
      this.snack.open('Failed to export Quotes data.', 'OK', {
        duration: 5000,
      });
    } finally {
      //this.importExportOperationLoader = false;
      this.fullLoaderService.hideLoader();
      // Reset operationType back to buyer after export to keep SWR keys stable
      this.operationType = 'buyerQuote';
    }
  }

  onStatusSelect(status: string, index: number, label: string) {
    if (this.selectedStatus.includes(status)) {
      return;
    }
    if (label === 'Quote') {
      this.activeIndex = index;
      this.selectedStatus = status;
      this.offset = 0;
      this.docStatus = status;
      console.log(
        'triggered status selection and now docstatus->',
        this.docStatus
      );
      this.fetchAllDocuments();
    } else if (label === 'RFQ') {
      this.router.navigate(['/operations/supplier-rfq-list'], {
        queryParams: {
          selectedStatus: status,
          label: label,
        },
      });
    }
  }

  viewQuotePreview(quoteId: number, supplierId: number, rfqId: number) {
    this.router.navigate(['/dashboard/quote/quote-details'], {
      queryParams: {
        supplierId: supplierId,
        quoteId: quoteId,
        rfqId: rfqId,
      },
    });
  }

  getRemainingTime(row: any): {
    label: string;
    color: string;
    tooltip: string;
  } {
    if (!row.quotedByDate || ['Lost', 'Declined'].includes(row.docStatus)) {
      if (row.docStatus == 'Declined') {
        return {
          label: '-',
          color: 'black',
          tooltip: 'You have declined this RFQ',
        };
      } else if (row.docStatus == 'Lost') {
        return {
          label: '-',
          color: 'black',
          tooltip: 'RFQ awarded to another Supplier',
        };
      }
      return {
        label: '-',
        color: 'black',
        tooltip: 'Quotation date Deadline not mentioned',
      };
    }

    const now = moment();
    const quoteDate = moment(row.quotedByDate);
    const diffInDays = quoteDate.diff(now, 'days');

    if (diffInDays > 7) {
      return {
        label: `New`,
        color: '#0BA716',
        tooltip: `RFQ due in ${diffInDays} days`,
      };
    } else if (diffInDays >= 4 && diffInDays <= 7) {
      return {
        label: `Standard`,
        color: '#FD8900',
        tooltip: `RFQ due in ${diffInDays} days`,
      };
    } else if (diffInDays >= 1 && diffInDays <= 3) {
      return {
        label: `Urgent`,
        color: '#F60303',
        tooltip: `RFQ due in ${diffInDays} days`,
      };
    } else if (diffInDays < 0) {
      // return { label: 'Overdue', color: '#000000', tooltip: 'Quote window closed' };
      return { label: '-', color: '#000000', tooltip: 'Quote window closed' };
    } else {
      const diffInHours = quoteDate.diff(now, 'hours');
      const diffInMinutes = quoteDate.diff(now, 'minutes');
      const diffInSeconds = quoteDate.diff(now, 'seconds');

      if (diffInHours >= 1) {
        return {
          label: `Urgent (${diffInHours} hr${diffInHours > 1 ? 's' : ''} Left)`,
          color: '#F60303',
          tooltip: `RFQ due in ${diffInHours} hours`,
        };
      } else if (diffInMinutes >= 1) {
        return {
          label: `Urgent (${diffInMinutes} min${
            diffInMinutes > 1 ? 's' : ''
          } Left)`,
          color: '#F60303',
          tooltip: `RFQ due in ${diffInMinutes} minutes`,
        };
      } else if (diffInSeconds >= 1) {
        return {
          label: `Urgent (${diffInSeconds} sec${
            diffInSeconds > 1 ? 's' : ''
          } Left)`,
          color: '#F60303',
          tooltip: `RFQ due in ${diffInSeconds} seconds`,
        };
      } else {
        // return { label: 'Overdue', color: '#000000', tooltip: 'Quote window closed'};
        return { label: '-', color: '#000000', tooltip: 'Quote window closed' };
      }
    }
  }

  getRemainingTimeForQuoteDate(row: any): {
    label: string;
    color: string;
    tooltip: string;
  } {
    const now = moment();
    const quoteDate = moment(row.quotedByDate);
    const diffInDays = quoteDate.diff(now, 'days');

    if (diffInDays > 7) {
      return {
        label: `New`,
        color: '#0BA716',
        tooltip: `RFQ due in ${diffInDays} days`,
      };
    } else if (diffInDays >= 4 && diffInDays <= 7) {
      return {
        label: `Standard`,
        color: '#FD8900',
        tooltip: `RFQ due in ${diffInDays} days`,
      };
    } else if (diffInDays >= 1 && diffInDays <= 3) {
      return {
        label: `Urgent`,
        color: '#F60303',
        tooltip: `RFQ due in ${diffInDays} days`,
      };
    } else if (diffInDays < 0) {
      return {
        label: 'Overdue',
        color: '#000000',
        tooltip: 'Quote window closed',
      };
    } else {
      const diffInHours = quoteDate.diff(now, 'hours');
      const diffInMinutes = quoteDate.diff(now, 'minutes');
      const diffInSeconds = quoteDate.diff(now, 'seconds');

      if (diffInHours >= 1) {
        return {
          label: `Urgent (${diffInHours} hr${diffInHours > 1 ? 's' : ''} Left)`,
          color: '#F60303',
          tooltip: `RFQ due in ${diffInHours} hours`,
        };
      } else if (diffInMinutes >= 1) {
        return {
          label: `Urgent (${diffInMinutes} min${
            diffInMinutes > 1 ? 's' : ''
          } Left)`,
          color: '#F60303',
          tooltip: `RFQ due in ${diffInMinutes} minutes`,
        };
      } else if (diffInSeconds >= 1) {
        return {
          label: `Urgent (${diffInSeconds} sec${
            diffInSeconds > 1 ? 's' : ''
          } Left)`,
          color: '#F60303',
          tooltip: `RFQ due in ${diffInSeconds} seconds`,
        };
      } else {
        return {
          label: 'Overdue',
          color: '#000000',
          tooltip: 'Quote window closed',
        };
      }
    }
  }

  async fetchAllDocuments() {
    // Ensure normal list queries always use buyer context
    this.operationType = 'buyerQuote';
    const q: BuyerQuoteQuery = this.buildQuoteQuery(1);
    try {
      const key = this.quoteSWR.keyOf(q);
      const needsResubscribe = this.currentQuoteQueryKey !== key;
      const cached = this.quoteSWR.getCached(q);
      this.showLoader = !cached;

      if (needsResubscribe) {
        if (this.quoteListSub) {
          this.quoteListSub.unsubscribe();
          this.quoteListSub = null;
        }
        this.currentQuoteQueryKey = key;
        this.quoteListSub = this.quoteSWR.getList$(q, true).subscribe(async (response) => {
          if (!response || !Array.isArray(response.rows)) return;
          const enrichedRows = await Promise.all(
            response.rows.map(async (rfq: any) => {
              const currentDate = new Date();
              const quotedByDate = new Date(rfq.quotedByDate);

              if (rfq.docStatus === 'Unactioned' && quotedByDate < currentDate) {
                rfq.docStatus = 'Expired';
              }
              if (this.expandedRowId === null) {
                this.expandedRowId = rfq.rfqId;
              }

              rfq.statusesStages = this.buildRfqStages(rfq);
              rfq.statusesStages = this.buildOtherStages(rfq);

              return rfq;
            })
          );

          this.documentData = enrichedRows;
          console.log("documentData",this.documentData);
          this.documentData = [...this.documentData];
          this.totalRecords = response.totalElements || 0;

          if (!this.autoExpandDone && this.documentData.length > 0) {
            setTimeout(() => {
              try {
                const firstRow = this.documentData[0];
                this.expandedRowId = firstRow.rfqId;
                this.expandedRowIndex = 0;
                if (this.table && this.table.rowDetail) {
                  try { this.table.rowDetail.collapseAllRows(); } catch {}
                  this.table.rowDetail.toggleExpandRow(firstRow);
                  this.autoExpandDone = true;
                }
              } catch (e) {
                console.warn('Auto-expand first row failed:', e);
              }
            }, 0);
          }
          this.showLoader = false;
          this.cdr.markForCheck();
        });
      }

      if (!cached) {
        this.fullLoaderService.showLoader();
        try {
          await this.quoteSWR.refresh(q);
        } finally {
          this.fullLoaderService.hideLoader();
        }
      } else {
        this.quoteSWR.refresh(q);
      }
    } catch (error) {
      console.error('Error fetching documents', error);
    } finally {
      this.showLoader = false;
      this.cdr.markForCheck();
    }
  }

  async fetchArchivedAllDocuments() {
    // Ensure archived list queries always use buyer context
    this.operationType = 'buyerQuote';
    const q: BuyerQuoteQuery = this.buildQuoteQuery(0);
    const key = this.quoteSWR.keyOf(q);
    const needsResubscribe = this.currentQuoteArchivedQueryKey !== key;
    const cached = this.quoteSWR.getCached(q);
    this.showLoader = !cached;

    if (needsResubscribe) {
      if (this.quoteArchivedSub) {
        this.quoteArchivedSub.unsubscribe();
        this.quoteArchivedSub = null;
      }
      this.currentQuoteArchivedQueryKey = key;
      this.quoteArchivedSub = this.quoteSWR.getList$(q, true).subscribe(async (response) => {
        if (!response || !Array.isArray(response.rows)) return;
        const enrichedRows = await Promise.all(
          response.rows.map(async (rfq: any) => {
            const rfqStatusName = this.rfqStatuses[rfq.rfqStatus - 1];
            rfq.docStatus = rfqStatusName;
            rfq.rfqDateFormatted = rfq.rfqDate ? moment(rfq.rfqDate).format('DD/MM/YYYY') : '-';
            rfq.quotationDateFormatted = rfq.quotationDate ? moment(rfq.quotationDate).format('DD/MM/YYYY') : '-';
            rfq.remainingQuote = this.getRemainingTimeForQuoteDate(rfq);
            rfq.quoteCount = (rfq.supplierQuotationList || []).length;
            return rfq;
          })
        );
        this.archivedDocumentData = enrichedRows;
        this.archivedTotalRecords = response.totalElements || 0;
        this.archivedDocumentData = [...this.archivedDocumentData];
        this.showLoader = false;
        this.cdr.markForCheck();
      });
    }

    if (!cached) {
      this.fullLoaderService.showLoader();
      try {
        await this.quoteSWR.refresh(q);
      } finally {
        this.fullLoaderService.hideLoader();
      }
    } else {
      this.quoteSWR.refresh(q);
    }
  }

  setRowClass = (row: any) => {
    return 'green-row-background';
  };

  rowIdentity = (row: any) => row.rfqId;

  ngOnDestroy() {
    if (this.quoteListSub) {
      this.quoteListSub.unsubscribe();
      this.quoteListSub = null;
    }
    if (this.quoteArchivedSub) {
      this.quoteArchivedSub.unsubscribe();
      this.quoteArchivedSub = null;
    }
  }

  toggleSelection(item: any) {
    item.selected = !item.selected;
    console.log(
      'Selected items:',
      this.items.filter((i) => i.selected)
    );
    this.updateSelectedColumns();
  }

  archivedToggleSelection(item: any) {
    item.selected = !item.selected;
    console.log(
      'Selected items:',
      this.archivedItems.filter((i) => i.selected)
    );
    this.updateArchivedSelectedColumns();
  }

  onScroll(): void {
    const menuContent = document.querySelector('.menu-content') as HTMLElement;
    // Check if we've reached the bottom of the menu content
    if (
      menuContent.scrollTop + menuContent.clientHeight >=
        menuContent.scrollHeight &&
      !this.isLoading
    ) {
      if (this.supplierUsersList.length == this.userlimit * this.useroffset) {
        this.fetchUsers();
      } else {
        this.isLoading = false;
      }
    }
  }

  // Fetch users based on pagination offset and limit
  async fetchUsers(): Promise<void> {
    this.isLoading = true;

    try {
      const response = await this.SettingsService.fetchUserBySupplierId(
        Number(this.cookieService.get('userId')), // supplierId
        this.userlimit, // limit
        this.useroffset // offset
      ).toPromise();

      if (response && Array.isArray(response.rows)) {
        this.supplierUsersList = [...this.supplierUsersList, ...response.rows];
        this.useroffset++; // Increment offset for next batch of users

        console.log('supplierUserList', this.supplierUsersList);
      } else {
        console.error('Invalid response structure:', response);
      }
    } catch (error) {
      console.error('Error fetching supplier users:', error);
    } finally {
      this.isLoading = false;
    }
  }

  updateSelectedColumns() {
    // Create a map of label to prop
    this.selectedColumns = this.items
      .filter((item) => item.selected) // Filter selected items
      .map((item) => ({ label: item.label, prop: item.prop })); // Create key-value pairs (label -> prop)
  }

  updateArchivedSelectedColumns() {
    this.archivedSelectedColumns = this.archivedItems
      .filter((item) => item.selected) // Filter selected items
      .map((item) => ({ label: item.label, prop: item.prop })); // Create key-value pairs (label -> prop)

    console.log('archieve selected columns', this.archivedSelectedColumns);
  }
  isDate(value: any): boolean {
    return value instanceof Date || !isNaN(Date.parse(value));
  }

  // Method to handle page change event from ngx-datatable
  onPageChange(event: any) {
    this.offset = event.offset; // Update offset from the page change event
    this.selectedRfq = [];
    this.fetchAllDocuments(); // Fetch data with new offset
  }

  // Method to handle search functionality
  onSearch() {
    setTimeout(() => {
      this.offset = 0;

      this.fetchAllDocuments();
    }, 0);
  }

  // Handle sort change event from ngx-datatable
  onSort(event: any) {
    const sort = event.sorts[0];
    this.sortField = sort.prop;
    this.sortDirection = sort.dir;

    // Apply sorting and fetch data accordingly
    // Note: Sorting in your backend should be implemented to support `sortField` and `sortDirection`
    this.fetchAllDocuments();
  }

  onArchivedSort(event: any) {}

  onArchivedPageChange(event: any) {
    this.archivedOffset = event.offset; // Update offset from the page change event
    this.fetchArchivedAllDocuments(); // Fetch data with new offset
  }

  async OpenRfq(rfqDetailsId: number, supplierId: number) {
    const newWindow = window.open('', '_blank'); // Open immediately

    if (!newWindow) {
      alert('Popup blocked. Please allow popups for this site.');
      return;
    }

    let data = {
      supplierId: supplierId,
      rfqId: rfqDetailsId,
    };

    try {
      const pdf = await this.SettingsService.generateSupplierRfqAttachment(
        data
      );
      const uint8Array = new Uint8Array(pdf.data);
      const blob = new Blob([uint8Array], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);

      newWindow.location.href = url;
    } catch (error) {
      newWindow.close(); // Cleanup
      console.error('Failed to open RFQ PDF', error);
      alert('Failed to open PDF. Please try again.');
    }
  }

  async downloadRfq(rfqDetailsId: number, supplierId: number, refNo: string) {
    this.showLoader = true;

    let fileName = refNo + '.pdf';

    let data = {
      supplierId: supplierId,
      rfqId: rfqDetailsId,
    };
    const pdf = await this.SettingsService.generateSupplierRfqAttachment(data);

    const uint8Array = new Uint8Array(pdf.data);
    const blob = new Blob([uint8Array], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);

    // Create a temporary <a> element
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    this.showLoader = false;
  }

  exportAll() {
    this.showLoader = true;

    let exportData: any[] = [];

    this.documentData.forEach((docDetails) => {
      exportData.push({
        Buyer: docDetails.companyName,
        'Document Type': docDetails.docType,
        Reference: docDetails.rfqRefNumber,
        // "Approved By": docDetails.approvedBy,
        Status: docDetails.docStatus,
        Date: docDetails.rfqDate,
      });
    });

    (async () => {
      const XLSX = await import('xlsx');
      const ws = XLSX.utils.json_to_sheet(exportData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'RFQ Data');
      XLSX.writeFile(wb, 'RFQ Data.xlsx');
    })();

    this.showLoader = false;
  }

  toggleVisibility() {
    this.isFilterExpand = !this.isFilterExpand;
  }

  // toggleArchived() {
  //   this.isArchivedExpand = !this.isArchivedExpand;
  //   if (this.isArchivedExpand && this.heading) {
  //     this.heading.nativeElement.scrollIntoView({
  //       behavior: 'smooth', // Smooth scroll
  //       block: 'start', // Align the section to the top of the viewport
  //     });
  //     setTimeout(() => {
  //       if (this.archivedSection) {
  //         this.heading.nativeElement.scrollIntoView({
  //           behavior: 'smooth',
  //           block: 'start', // Align the table at the top of the viewport after heading
  //         });
  //       }
  //     }, 100);
  //   }
  // }

  async toggleArchived() {
    this.isArchivedExpand = !this.isArchivedExpand;
    if (this.isArchivedExpand) {
      // Lazy-load archived data on first expand
      if (!this.archivedLoaded) {
        await this.fetchArchivedAllDocuments();
        this.archivedLoaded = true;
      }

      if (this.heading) {
        this.heading.nativeElement.scrollIntoView({
          behavior: 'smooth', // Smooth scroll
          block: 'start', // Align the section to the top of the viewport
        });
        setTimeout(() => {
          if (this.archivedSection) {
            this.heading.nativeElement.scrollIntoView({
              behavior: 'smooth',
              block: 'start', // Align the table at the top of the viewport after heading
            });
          }
        }, 100);
      }
    }
  }

  isColumnVisible(prop: string): boolean {
    const column = this.columns.find((col) => col.prop === prop);
    return column ? column.visible : false;
  }

  search() {}
  cancelFilter() {
    this.fromDate = null;
    this.toDate = null;
    this.offset = 0;
    this.archivedOffset = 0;
    this.selectedStatus = 'ALL';
    this.docStatus = '';
    this.fetchAllDocuments();
    this.fetchArchivedAllDocuments();
  }

  toggleColumn(column: any) {
    column.visible = !column.visible;
  }

  toggleSelectAll(event: any, section: string) {
    const checked = event.target.checked;
    // const ids = this.documentData.map(item => item.supplierRfqDetailsId);
    const ids = this.documentData.map((item) => item.quoteId);

    if (section == 'active') {
      if (checked) {
        // this.selectedRfq = this.documentData.map(item => item.supplierRfqDetailsId);
        this.selectedRfq = this.documentData.map((item) => item.quoteId);
      } else {
        this.selectedRfq = [];
      }
    } else {
      if (checked) {
        this.selectedArchivedRfq = this.archivedDocumentData.map(
          (item) => item.quoteId
        );
      } else {
        this.selectedArchivedRfq = [];
      }
    }
  }

  selectDeselectRfq(
    event: any,
    supplierRfqDetailsId: any,
    quoteId: any,
    section: string,
    owner: any
  ) {
    const checked = event.target.checked;

    if (section == 'active') {
      if (checked) {
        this.selectedRfq.push(quoteId);
        //  this.selectedRfqDetails.push(supplierRfqDetailsId);
        console.log("selectedRfq",this.selectedRfq);
        console.log('owner', owner);
        if (owner !== null) {
          this.snack.open(
            `User is already assigned to Quote ID ${quoteId}`,
            'OK',
            {
              duration: 5000,
            }
          );
        }
      } else {
        this.selectedRfq = this.selectedRfq.filter((id) => id !== quoteId);
      }
    } else {
      if (checked) {
        this.selectedArchivedRfq.push(quoteId);
      } else {
        this.selectedArchivedRfq = this.selectedArchivedRfq.filter(
          (id) => id !== quoteId
        );
      }
    }
  }

//   async rfqOperation(operation: string) {
//     if (operation == 'unarchive') {
//       if (this.selectedArchivedRfq.length == 0) {
//         this.snack.open('Please select atleast one', 'OK', {
//           duration: 3000,
//         });
//         return;
//       }

//       this.showLoader = true;
//       await this.SettingsService.quoteOperations({
//         operation: operation,
//         selectedRfqId: this.selectedArchivedRfq,
//       });

//       // Optimistically move items from archived -> active
//       const unarchivedIds = new Set(this.selectedArchivedRfq);
//       const toUnarchive = this.archivedDocumentData.filter((row: any) => unarchivedIds.has(row.quoteId));
//       this.archivedDocumentData = this.archivedDocumentData.filter((row: any) => !unarchivedIds.has(row.quoteId));
//       if (toUnarchive.length > 0) {
//         this.documentData = [...toUnarchive, ...this.documentData];
//         this.totalRecords += toUnarchive.length;
//         this.archivedTotalRecords = Math.max(0, this.archivedTotalRecords - toUnarchive.length);
//       }

//       // Patch caches for current active/archived pages
//       const qArchived = this.buildQuoteQuery(0);
//       const qActive = this.buildQuoteQuery(1);
//       this.quoteSWR.patchList(qArchived, (resp: any) => {
//         const rows = (resp?.rows || []).filter((r: any) => !unarchivedIds.has(r.quoteId));
//         const total = Math.max(0, (resp?.totalElements ?? 0) - toUnarchive.length);
//         return { ...resp, rows, totalElements: total };
//       });
//       this.quoteSWR.patchList(qActive, (resp: any) => {
//         const rows = toUnarchive.concat(resp?.rows || []);
//         const total = (resp?.totalElements ?? 0) + toUnarchive.length;
//         return { ...resp, rows, totalElements: total };
//       });

//       // Background refresh
//       this.quoteSWR.refresh(qActive);
//       if (this.archivedLoaded) this.quoteSWR.refresh(qArchived);

//       this.snack.open('Items unarchived', 'OK', { duration: 3000 });
//     } else {
//       if (this.selectedRfq.length == 0) {
//         this.snack.open('Please select atleast one.', 'OK', {
//           duration: 3000,
//         });
//         return;
//       }

//       let data = {
//         operation: operation,
//         selectedRfqId: this.selectedRfq,
//       };

//       if (operation == 'archive') {
//         this.showLoader = true;
//         await this.SettingsService.quoteOperations(data);

//         // Optimistically move items from active -> archived
//         const archivedIds = new Set(this.selectedRfq);
//         const toArchive = this.documentData.filter((row: any) => archivedIds.has(row.quoteId));
//         this.documentData = this.documentData.filter((row: any) => !archivedIds.has(row.quoteId));
//         if (toArchive.length > 0 && this.archivedLoaded) {
//           this.archivedDocumentData = [...toArchive, ...this.archivedDocumentData];
//           this.archivedTotalRecords += toArchive.length;
//         }
//         this.totalRecords = Math.max(0, this.totalRecords - toArchive.length);

//         // Patch caches for current active/archived pages
//         const qActive = this.buildQuoteQuery(1);
//         const qArchived = this.buildQuoteQuery(0);
//         this.quoteSWR.patchList(qActive, (resp: any) => {
//           const rows = (resp?.rows || []).filter((r: any) => !archivedIds.has(r.quoteId));
//           const total = Math.max(0, (resp?.totalElements ?? 0) - toArchive.length);
//           return { ...resp, rows, totalElements: total };
//         });
//         if (this.archivedLoaded) {
//           this.quoteSWR.patchList(qArchived, (resp: any) => {
//             const rows = toArchive.concat(resp?.rows || []);
//             const total = (resp?.totalElements ?? 0) + toArchive.length;
//             return { ...resp, rows, totalElements: total };
//           });
//         }

//         // Reset expanded row if the archived selection contained it
//         if (this.expandedRowId && archivedIds.has(this.expandedRowId)) {
//           this.expandedRowId = null;
//           if (this.documentData.length > 0) {
//             const first = this.documentData[0];
//             this.expandedRowId = first.rfqId;
//             try {
//               if (this.table && this.table.rowDetail) {
//                 this.table.rowDetail.collapseAllRows();
//                 this.table.rowDetail.toggleExpandRow(first);
//               }
//             } catch {}
//           }
//         }

//         this.snack.open('Items archived', 'OK', { duration: 3000 });
//       }
//     }

//     // Background revalidation only; no blocking loaders
//     const qActive = this.buildQuoteQuery(1);
//     const qArchived = this.buildQuoteQuery(0);
//     this.quoteSWR.refresh(qActive);
//     if (this.archivedLoaded) {
//       this.quoteSWR.refresh(qArchived);
//     }
//     this.selectedArchivedRfq = [];
//     this.selectedRfq = [];
//     this.showLoader = false;
//   }
    async rfqOperation(operation: string) {
    if (operation == 'unarchive') {
      if (this.selectedArchivedRfq.length == 0) {
        this.snack.open('Please select atleast one', 'OK', {
          duration: 3000,
        });
        return;
      }

      this.showLoader = true;
      await this.SettingsService.quoteOperations({
        operation: operation,
        selectedRfqId: this.selectedArchivedRfq,
      });

      // Optimistically move items from archived -> active
      const unarchivedIds = new Set(this.selectedArchivedRfq);
      console.log("unarchivedIds",unarchivedIds);
      const toUnarchive = this.archivedDocumentData.filter((row: any) => unarchivedIds.has(row.quoteId));
      this.archivedDocumentData = this.archivedDocumentData.filter((row: any) => !unarchivedIds.has(row.quoteId));
      // If active list is present, prepend the unarchived rows
      if (toUnarchive.length > 0) {
        this.documentData = [...toUnarchive, ...this.documentData];
        this.totalRecords += toUnarchive.length;
        this.archivedTotalRecords = Math.max(0, this.archivedTotalRecords - toUnarchive.length);
      }

      // Patch caches for current pages
      const qArchived = this.buildQuoteQuery(0);
      const qActive = this.buildQuoteQuery(1);
      this.quoteSWR.patchList(qArchived, (resp: any) => {
        const rows = (resp?.rows || []).filter((r: any) => !unarchivedIds.has(r.quoteId));
        const total = Math.max(0, (resp?.totalElements ?? 0) - toUnarchive.length);
        return { ...resp, rows, totalElements: total };
      });
      this.quoteSWR.patchList(qActive, (resp: any) => {
        const rows = toUnarchive.concat(resp?.rows || []);
        const total = (resp?.totalElements ?? 0) + toUnarchive.length;
        return { ...resp, rows, totalElements: total };
      });

      this.snack.open('Items unarchived', 'OK', {
        duration: 3000,
      });
    } else {
      if (this.selectedRfq.length == 0) {
        this.snack.open('Please select atleast one.', 'OK', {
          duration: 3000,
        });
        return;
      }

      let data = {
        operation: operation,
        selectedRfqId: this.selectedRfq,
      };

      if (operation == 'archive') {
        this.showLoader = true;
        await this.SettingsService.quoteOperations(data);

        // Optimistically move items from active -> archived
        const archivedIds = new Set(this.selectedRfq);
        console.log("archiveIds",archivedIds);
        const toArchive = this.documentData.filter((row: any) => archivedIds.has(row.quoteId));
        this.documentData = this.documentData.filter((row: any) => !archivedIds.has(row.quoteId));
        if (toArchive.length > 0 && this.archivedLoaded) {
          this.archivedDocumentData = [...toArchive, ...this.archivedDocumentData];
          this.archivedTotalRecords += toArchive.length;
        }
        this.totalRecords = Math.max(0, this.totalRecords - toArchive.length);

        // Patch caches for current pages
        const qActive = this.buildQuoteQuery(1);
        const qArchived = this.buildQuoteQuery(0);
        this.quoteSWR.patchList(qActive, (resp: any) => {
          const rows = (resp?.rows || []).filter((r: any) => !archivedIds.has(r.quoteId));
          const total = Math.max(0, (resp?.totalElements ?? 0) - toArchive.length);
          return { ...resp, rows, totalElements: total };
        });
        if (this.archivedLoaded) {
          this.quoteSWR.patchList(qArchived, (resp: any) => {
            const rows = toArchive.concat(resp?.rows || []);
            const total = (resp?.totalElements ?? 0) + toArchive.length;
            return { ...resp, rows, totalElements: total };
          });
        }
        //Reset expanded row if the archived selection contained it
        if (this.expandedRowId && archivedIds.has(this.expandedRowId)) {
          this.expandedRowId = null;
          if (this.documentData.length > 0) {
            const first = this.documentData[0];
            this.expandedRowId = first.rfqId;
            try {
              if (this.table && this.table.rowDetail) {
                this.table.rowDetail.collapseAllRows();
                this.table.rowDetail.toggleExpandRow(first);
              }
            } catch {}
          }
        }

        this.snack.open('Items archived', 'OK', {
          duration: 3000,
        });
      }
      // } else if (operation == 'markAsOpen') {
      //   this.showLoader = true;
      //   await this.SettingsService.rfqOperations(data);
      //   this.showLoader = false;
      //   this.snack.open('Items marked as open', 'OK', {
      //     duration: 3000,
      //   });
      // } else if (operation == 'markAsUnopen') {
      //   this.showLoader = true;
      //   await this.SettingsService.rfqOperations(data);
      //   this.showLoader = false;
      //   this.snack.open('Items marked as unopen', 'OK', {
      //     duration: 3000,
      //   });
      // }
    }

    // Background revalidation only; no blocking loaders
    const qActive = this.buildQuoteQuery(1);
    const qArchived = this.buildQuoteQuery(0);
    this.quoteSWR.refresh(qActive);
    if (this.archivedLoaded) {
      this.quoteSWR.refresh(qArchived);
    }
    this.selectedArchivedRfq = [];
    this.selectedRfq = [];
    this.showLoader = false;
  }

  isChecked(quoteId: number, section: string) {
    if (section == 'active') {
      return this.selectedRfq.includes(quoteId);
    } else {
      return this.selectedArchivedRfq.includes(quoteId);
    }
  }
  // dashboard/quote/create/header?rfqId=335&quoteId=140
  openRfqDetails(rfqId: number) {
    console.log('asdddf');
    this.router.navigate(['/dashboard', 'quote', 'rfq-details', rfqId]);
  }
  openQuoteDetails(rfqId: number, quoteId: number) {
    this.router.navigate(['/dashboard', 'quote', 'create', 'header'], {
      queryParams: {
        rfqId: rfqId,
        quoteId: quoteId,
      },
    });
  }
  async restore(quoteId: number, operation: string) {
    console.log('Quote Id', quoteId);
    if (operation == 'unArchive') {
      this.showLoader = true;
      await this.SettingsService.quoteOperations({
        operation: operation,
        selectedRfqId: [quoteId],
      });
      // Optimistically move one item from archived -> active
      const idx = this.archivedDocumentData.findIndex((r: any) => r.quoteId === quoteId);
      if (idx !== -1) {
        const [row] = this.archivedDocumentData.splice(idx, 1);
        this.documentData = [row, ...this.documentData];
        this.totalRecords += 1;
        this.archivedTotalRecords = Math.max(0, this.archivedTotalRecords - 1);
        const qArchived = this.buildQuoteQuery(0);
        const qActive = this.buildQuoteQuery(1);
        this.quoteSWR.patchList(qArchived, (resp: any) => {
          const rows = (resp?.rows || []).filter((r: any) => r.quoteId !== quoteId);
          const total = Math.max(0, (resp?.totalElements ?? 0) - 1);
          return { ...resp, rows, totalElements: total };
        });
        this.quoteSWR.patchList(qActive, (resp: any) => {
          const rows = [row].concat(resp?.rows || []);
          const total = (resp?.totalElements ?? 0) + 1;
          return { ...resp, rows, totalElements: total };
        });
      }
      // Background refresh
      const qActive2 = this.buildQuoteQuery(1);
      const qArchived2 = this.buildQuoteQuery(0);
      this.quoteSWR.refresh(qActive2);
      if (this.archivedLoaded) this.quoteSWR.refresh(qArchived2);

      this.snack.open('Item unarchived', 'OK', { duration: 3000 });
      this.showLoader = false;
    }
  }

  toggleExpandedRow(row: any) {
    this.expandedRfqId = this.expandedRfqId === row.rfqId ? null : row.rfqId;
  }

  selectAllSuppliers() {}

  checkIfAllSelected() {}


  onAddClick() {
    // UI-only for now (e.g., open add-supplier dialog)
  }
  onCompareClick() {
    // UI-only for now
  }
  expandedRowId: number | null = null;
  expandedRowIndex: number | null = null;

  toggleExpandRow(row: any, index: number) {
    const clickedId = row?.rfqId;
    const isSameRow = this.expandedRowId === clickedId;

    // Always collapse existing expanded rows first to keep only one open
    if (this.table && this.table.rowDetail) {
      try {
        this.table.rowDetail.collapseAllRows();
      } catch {}
    }

    if (isSameRow) {
      // If clicking the same expanded row, collapse it
      this.expandedRowId = null;
      this.expandedRowIndex = null;
      return;
    }

    // Open the newly clicked row
    this.expandedRowId = clickedId;
    this.expandedRowIndex = index;

    if (this.table && this.table.rowDetail) {
      this.table.rowDetail.toggleExpandRow(row);
    }
  }

  // getRowHeight = (row: any): number => {
  //   if (this.expandedRowId !== undefined) {
  //     const expandedRow = this.documentData.find(r => r.rfqId === this.expandedRowId);

  //     if (expandedRow) {
  //       const itemCount = expandedRow.supplierQuotationList?.length || 0;
  //       return itemCount === 0 ? 100 : 200 * itemCount;
  //     } else {
  //       return 100;
  //     }
  //   } else {
  //     return 0;
  //   }

  // };

  getRowHeight = (row: any): number => {
    if (this.expandedRowId !== undefined) {
      const expandedRow = this.documentData.find(
        (r) => r.rfqId === this.expandedRowId
      );
      if (expandedRow) {
        const itemCount = expandedRow?.supplierQuotationList?.length || 0;

        if (itemCount === 0) {
          return 266;
        } else if (itemCount > 3) {
          return 480;
        } else {
          return itemCount * 120 + 266;
        }
      }
    }

    return 100; // collapsed row height
  };

  async fetchQuoteLineItemDetailsByQuoteId(quoteId: number) {
    this.showDetailLoader = true;
    this.showProductPopUp = true;

    try {
      this.quoteLineItemData =
        await this.SettingsService.fetchQuoteLineItemDetailsByQuoteId(quoteId);
    } catch (error) {
      console.error('Error fetching documents', error);
    } finally {
      this.showDetailLoader = false;
      this.cdr.markForCheck();
    }
  }

  toggleSidebar(value: boolean, section?: string) {
    if (!value) {
      this.quoteLineItemData = [];
    }
    this.showProductPopUp = value;
  }

  toggleShowColumn(section: string) {
    if (section == 'productCost') {
      this.showProductReqCost = !this.showProductReqCost;
    } else if (section == 'quoteCost') {
      this.showQuoteReqCost = !this.showQuoteReqCost;
    }
  }

  getStageColorClass(label: string, row: any): string {
    if (row.docStatus === 'Declined' || row.docStatus === 'Canceled') {
      return 'stage-declined';
    }

    // console.log('label received ->', label);
    switch (label) {
      case 'Declined':
        return 'stage-declined';
      case 'Expired':
        return 'stage-lapsed';
      default:
        return 'stage-completed';
    }
  }

  getCompleteIncompleteClass(stage: any): string {
    return stage.completed ? '' : 'stage-incomplete';
  }

  buildRfqStages(rfq: any) {
    const rfqStatusName=this.rfqStatuses[rfq.rfqStatus -1];
    rfq.docStatus=rfqStatusName;
    const sortedStages = (rfq.rfqStatusStages || []).sort(
      (a: any, b: any) =>
        new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
    );
    // if(sortedStages.length !==0){
    //   rfq.docStatus = sortedStages[sortedStages.length -1].statusName;
    // }

    const stagesArray: any[] = [];
    let hasAcknowledged = false;
    let hasDeclined = false;
    let hasUnactioned = false;
    let hasCreated = false;
    let createdDate = '';
    let hasDraft = false;

    for (let stage of sortedStages) {
      if (stage.statusName === 'Acknowledged') hasAcknowledged = true;
      else if (stage.statusName === 'Declined') hasDeclined = true;
      else if (stage.statusName === 'Unactioned') hasUnactioned = true;
      else if (stage.statusName === 'Created') hasCreated = true;
      else if (stage.statusName === 'Draft') {
        hasDraft = true;
        createdDate = this.formatDate(stage.createdAt);
      }
    }
    if (!hasCreated) {
      stagesArray.push({
        heading: this.getHeadingFromLabel('Created', 'RFQ'),
        label: 'RFQ Created',
        date:
          createdDate !== '' ? createdDate : this.formatRfqDate(rfq.rfqDate),
        completed: true,
      });
    }

    sortedStages.forEach((stage: any) => {
      stagesArray.push({
        heading: this.getHeadingFromLabel(stage.statusName, 'RFQ'),
        label:
          stage.statusName === 'Unactioned' ? `RFQ Sent(${rfq.rfqSupplierCount})` : `RFQ ${stage.statusName}`,
        date: this.formatDate(stage.createdAt),
        completed: true,
      });
    });

    if (rfq.docStatus === 'Unactioned' && !hasUnactioned) {
      stagesArray.push({
        heading: this.getHeadingFromLabel('Unactioned', 'RFQ'),
        label: `RFQ Sent(${rfq.rfqSupplierCount})`,
        date: this.formatDate(rfq.rfqDate),
        completed: true,
      });
    }
    // If RFQ is expired, append it at the end (if not already in stages)
    if (
      rfq.docStatus === 'Unactioned' &&
      this.isRFQExpired(rfq.quotedByDate)
    ) {
      stagesArray.push({
        heading: this.getHeadingFromLabel('Expired', 'RFQ'),
        label: 'RFQ Expired',
        date: this.formatDate(rfq.quotedByDate),
        completed: true,
      });
    }

    // if (!hasAcknowledged && !hasDeclined) {
    //   stagesArray.push({
    //     heading: this.getHeadingFromLabel('Acknowledged', 'RFQ'),
    //     label: 'Acknowledged',
    //     date: '',
    //     completed: false,
    //   });
    // }

    return stagesArray;
  }

  // buildRfqStages(rfq: any) {
  //   const rfqStatusName = this.rfqStatuses?.[rfq.rfqStatus - 1] ?? rfq.docStatus;
  //   rfq.docStatus = rfqStatusName;

  //   const sortedStages = Array.isArray(rfq.rfqStatusStages)
  //     ? [...rfq.rfqStatusStages].sort(
  //         (a: any, b: any) =>
  //           new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
  //       )
  //     : [];

  //   const presentStatuses = new Set(sortedStages.map((s: any) => s.statusName));
  //   const stagesArray: any[] = [];

  //   // Ensure a Created stage exists (top of the list) if not present in history
  //   if (!presentStatuses.has('Created')) {
  //     stagesArray.push({
  //       heading: this.getHeadingFromLabel('Created', 'RFQ'),
  //       label: 'Created',
  //       date: this.formatRfqDate(rfq.rfqDate),
  //       completed: true,
  //     });
  //   }

  //   // Map the historical stages in chronological order
  //   for (const stage of sortedStages) {
  //     stagesArray.push({
  //       heading: this.getHeadingFromLabel(stage.statusName, 'RFQ'),
  //       label:
  //         stage.statusName === 'Unactioned'
  //           ? `Sent(${rfq.rfqSupplierCount})`
  //           : stage.statusName,
  //       date: this.formatDate(stage.createdAt),
  //       completed: true,
  //     });
  //   }

  //   // If RFQ is currently Unactioned but not in the stage history, add a synthetic marker
  //   if (rfq.docStatus === 'Unactioned' && !presentStatuses.has('Unactioned')) {
  //     stagesArray.push({
  //       heading: this.getHeadingFromLabel('Unactioned', 'RFQ'),
  //       label: `Sent(${rfq.rfqSupplierCount})`,
  //       date: this.formatDate(rfq.rfqDate),
  //       completed: true,
  //     });
  //   }
  //   const isExpired = this.isRFQExpired(rfq.quotedByDate);
  //   console.log('isExpired check ->', isExpired);
  //   // Append Expired only if past the quotedByDate and not already included
  //   if (
  //     rfq.docStatus === 'Unactioned' &&
  //     isExpired
  //   ) {
  //     stagesArray.push({
  //       heading: this.getHeadingFromLabel('Expired', 'RFQ'),
  //       label: 'Expired',
  //       date: this.formatDate(rfq.quotedByDate),
  //       completed: true,
  //     });
  //   }

  //   return stagesArray;
  // }

  buildOtherStages(rfq: any) {
    let stagesArray = rfq.statusesStages || [];

    let quoteCount = rfq.supplierQuotationList?.length || 0;

    if (quoteCount > 0) {
      const lastQuotationDate =
        rfq.supplierQuotationList[quoteCount - 1]?.quotationDate;

      stagesArray.push({
        heading: this.getHeadingFromLabel('Quoted', 'Quote'),
        label: `Quotation Received(${quoteCount})`,
        date: lastQuotationDate ? this.formatDate(lastQuotationDate) : '',
        completed: true,
      });
    } else {
      // Handle case when there are no quotes
      stagesArray.push({
        heading: this.getHeadingFromLabel('Quoted', 'Quote'),
        label: 'Quotation Received(0)',
        date: '',
        completed: false,
      });
    }

    stagesArray.push({
      heading: 'PO Created',
      label: 'PO Created',
      date: '',
      completed: false,
    });

    stagesArray.push({
      heading: 'PO Confirmation',
      label: 'PO Confirmation',
      date: '',
      completed: false,
    });

    stagesArray.push({
      heading: 'Delivered Onboard',
      label: 'Delivered',
      date: '',
      completed: false,
    });

    return stagesArray;
  }
  async onUserMenuOpened() {
    console.log('User menu opened');
    console.log('Current supplierUsersList:', this.supplierUsersList)
    if (!this.supplierUsersList.length && !this.isLoading) {
      await this.fetchUsers();
    }
    console.log('Supplier Users List:', this.supplierUsersList);
  }

  openChat(rfq: any, supplier: any) {
    this.headerData = {
      rfqId: rfq.rfqId,
      rfqDate: rfq.rfqDate,
      rfqRefNumber: rfq.rfqRefNumber,
      vesselName: rfq.vesselName,
      vesselImoNumber: rfq.vesselImoNumber,
      portName: rfq.portName,
      vesselEta: rfq.vesselEta,
      vesselEtd: rfq.vesselEtd,
      buyerId: rfq.buyerId || Number(this.cookieService.get('userId')),
      supplierId: supplier.supplierId,
    };

    this.isChatOpen = true;
  }

  closeChat() {
    this.isChatOpen = false;
  }

  get userIdAsString(): string {
    return this.userId.toString();
  }

  exchangeRatesCache: { [base: string]: any } = {};

  getConvertedAmount(supplier: any, buyerCurrency: string): string {
    const amount = supplier.totalReqCost;
    if (!amount) return 'N/A';

    // when toggle is OFF -> show buyer currency
    if (!this.isWrapDescription) {
      return `${buyerCurrency ? buyerCurrency : ''} ${amount}`;
    }

    // when toggle is ON -> convert to supplier currency
    const supplierCurrency = supplier.quoteCurrency || 'EUR';

    if (!supplierCurrency) {
      return `${buyerCurrency ? buyerCurrency : ''} ${amount}`; // fallback
    }

    const rates = this.exchangeRatesCache[buyerCurrency];

    if (rates && rates[supplierCurrency]) {
      const converted = (amount * rates[supplierCurrency]).toFixed(3);
      return `${supplierCurrency} ${converted}`;
    }

    // currency code not found in API rates
    // this.snack.open(
    //   `Currency code "${supplierCurrency}" not supported for supplier "${supplier.supplierName}"`,
    //   'Close',
    //   { duration: 4000 }
    // );
    return `${buyerCurrency} ${amount}`;
  }

  // toggleWrapDescription(event: any, row: any,section:string) {

  //   if(section=='quote'){

  //     this.showQuoteReqCost = event.checked;

  //     if (this.showQuoteReqCost) {
  //       // fetch conversion rates for buyer currency if not already cached
  //       const baseCurrency = row.rfqReqCurrencyCode;
  
  //       if (!baseCurrency) {
  //         this.snack.open(`Buyer does not have a currency code`, 'Close', {
  //           duration: 4000,
  //         });
  //         return;
  //       }
  
  //       if (!this.exchangeRatesCache[baseCurrency]) {
  //         const url = `https://v6.exchangerate-api.com/v6/${environment.exchangeRate_apiKey}/latest/${baseCurrency}`;
  //         this.http.get(url).subscribe((res: any) => {
  //           if (res.result === 'success') {
  //             this.exchangeRatesCache[baseCurrency] = res.conversion_rates;
  //             console.log(
  //               'Exchange rates fetched successfully:',
  //               res.conversion_rates
  //             );
  //           } else {
  //             console.error('API error:', res['error-type']);
  //           }
  //         });
  //       }
  //     }

  //   }

  //   else if(section=='quote'){

  //     this.showProductReqCost = event.checked;


  //     if (this.showProductReqCost) {
  //       // fetch conversion rates for buyer currency if not already cached
  //       const baseCurrency = row.rfqReqCurrencyCode;
  
  //       if (!baseCurrency) {
  //         this.snack.open(`Buyer does not have a currency code`, 'Close', {
  //           duration: 4000,
  //         });
  //         return;
  //       }
  
  //       if (!this.exchangeRatesCache[baseCurrency]) {
  //         const url = `https://v6.exchangerate-api.com/v6/${environment.exchangeRate_apiKey}/latest/${baseCurrency}`;
  //         this.http.get(url).subscribe((res: any) => {
  //           if (res.result === 'success') {
  //             this.exchangeRatesCache[baseCurrency] = res.conversion_rates;
  //             console.log(
  //               'Exchange rates fetched successfully:',
  //               res.conversion_rates
  //             );
  //           } else {
  //             console.error('API error:', res['error-type']);
  //           }
  //         });
  //       }
  //     }

  //   }
    

   
  // }

  toggleWrapDescription(event: any, row: any,section:string) {

    if(section=='quote'){

       this.showQuoteReqCost = event.checked;

        const baseCurrency = row.rfqReqCurrencyCode;
  
        if (!baseCurrency) {
          this.snack.open(`Buyer does not have a currency code`, 'Close', {
            duration: 4000,
          });
          return;
        }
  
        if (!this.exchangeRatesCache[baseCurrency]) {
          const url = `https://v6.exchangerate-api.com/v6/${environment.exchangeRate_apiKey}/latest/${baseCurrency}`;
          this.http.get(url).subscribe((res: any) => {
            if (res.result === 'success') {
              this.exchangeRatesCache[baseCurrency] = res.conversion_rates;
              console.log(
                'Exchange rates fetched successfully:',
                res.conversion_rates
              );
            } else {
              console.error('API error:', res['error-type']);
            }
          },
          (error: any) => {
            if (error && error.status === 429) {
              this.snack.open(
                'Currency exchange API limit exceeded. Please renew the subscription to view actual conversion values. Some users may experience disruptions in currency conversion functionality.',
                'OK',
                { duration: 7000 }
              );
            } else {
              console.error('Error fetching exchange rates:', error);
            }
          });
        }
      

    }


    else{
      this.showProductReqCost = event.checked;

      // const baseCurrency = row.rfqReqCurrencyCode;
  
      // if (!baseCurrency) {
      //   this.snack.open(`Buyer does not have a currency code`, 'Close', {
      //     duration: 4000,
      //   });
      //   return;
      // }

      // if (!this.exchangeRatesCache[baseCurrency]) {
      //   const url = `https://v6.exchangerate-api.com/v6/${environment.exchangeRate_apiKey}/latest/${baseCurrency}`;
      //   this.http.get(url).subscribe((res: any) => {
      //     if (res.result === 'success') {
      //       this.exchangeRatesCache[baseCurrency] = res.conversion_rates;
      //       console.log(
      //         'Exchange rates fetched successfully:',
      //         res.conversion_rates
      //       );
      //     } else {
      //       console.error('API error:', res['error-type']);
      //     }
      //   });
      // }

    }


   
  }


  togglePreview(value: boolean, section:string, row?: any ) {
    this.previewSection = value;
    this.previewDocs = [];
    console.log(row.buyerAttachments,row.lineItemAttachments,'row')
    if (row && section == 'rfq') {
       this.previewDocs = [...row.buyerAttachments, ...row.lineItemAttachments]
    }
    else if(row && section == 'quote'){
      this.previewDocs = [...row.quoteHeaderAttachments, ...row.quoteLineItemAttachments]
    }
  }




  toggleContactPopUp(value: boolean, row?: any){
    this.showContactPopup = value;
  
    if(value){
      if(row){
  
        this.selectedSupplier = {
          companyName: row.supplierName,
          contactPerson: row.supplierContact,
          email: row.supplierEmail,
          phone: row.supplierPhone,
          address: row.supplierAddress,
          fax: row.supplierFax
      
        };


      }
  
    }
  }


  async downloadQuote( row:any, supplier:any ) {

    this.fullLoaderService.showLoader()
    
    const name = Math.random().toString(36).substring(2, 10);
  
    const fileName = `DOC-${name}.pdf`;

    
    let data = {
      supplierId: Number(supplier.supplierId),
      rfqId: Number(row.rfqId),
      quoteId:Number(supplier.quoteId)
    }
    const pdf = await this.SettingsService.generateQuoteAttachment(data)

    const uint8Array = new Uint8Array(pdf.data);
    const blob = new Blob([uint8Array], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);


    // Create a temporary <a> element
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName; 
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    this.fullLoaderService.hideLoader()

  }

  async downloadRfqForBuyer(refNo: string, row:any ) {

    this.fullLoaderService.showLoader()
    
    let fileName = refNo +'.pdf';
    
    let data = {
      rfqId: Number(row.rfqId)
    }
    const pdf = await this.SettingsService.generateRfqAttachmentForBuyer(data)

    const uint8Array = new Uint8Array(pdf.data);
    const blob = new Blob([uint8Array], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);


    // Create a temporary <a> element
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName; 
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    this.fullLoaderService.hideLoader()

  }

  async generateRFQExcelForBuyer(rfqId: number) {

    this.fullLoaderService.showLoader()

    let params = {
          rfqId: Number(rfqId)
        }
    const result = await this.SettingsService.fetchBuyerRfqAttachmentExcelData(params)
    
    console.log(result,'result')

    const fileName = result.rfqData.rfqRefNumber + '.xlsx'

    const data = {
      rfqRef: result.rfqData.rfqRefNumber,
      rfqDate: result.rfqData.rfqDate,
      preferredCurrency: result.rfqData.currencyId.currencyCode,
      vesselName: result.rfqData.vesselName,
      imoNumber: result.rfqData.vesselImoNumber,
      quoteByDate: result.rfqData.quotedByDate,
      requestedDeliveryDate: result.rfqData.requestedDeliveryDate,
      buyerDetails: {
        name: result.rfqData.buyerCompanyName,
        address: result.rfqData.companyAddress,
        contact: result.rfqData.contact,
        phone: result.rfqData.companyPhoneNumber,
        email: result.rfqData.companyEmailId,
        mpsBuyerCode: result.rfqData.mpsBuyerCode,
      },
      freightForwarderDetails: {
        PIC: result.rfqData.rffdPic,
        phone: result.rfqData.rffdphone,
        fax: result.rfqData.rffdfax,
        email: result.rfqData.rffdemailId,
        address: result.rfqData.rffdaddress,
      },
      portAgentDetails: {
        name: result.rfqData.portAgentNumber,
        phone: result.rfqData.rfqPortAgentphone,
        fax: result.rfqData.rfqPortAgentfax,
        email: result.rfqData.rfqPortAgentemailId,
        contact: result.rfqData.rfqPortAgentContact,
      },
      portDetails: {
        portName: result.rfqData.portName,
        vesselETA: result.rfqData.vesselEta,
        vesselETD: result.rfqData.vesselEtd,
      },
      lineItems: result.supplierLineItemdata.map((item: { partNumber: any; itemDescription: any; quantity: any; uom: any; buyerComments: any; mappedSuppliers: any[]; }, index: number) => ({
        srNo: index + 1,
        partNumber: item.partNumber,
        itemDescription: item.itemDescription,
        qty: item.quantity,
        uom: item.uom,
        buyerComments: item.buyerComments,
        attachedSuppliers: item.mappedSuppliers.map(supplier => ({
          name: supplier.supplierName,
          email: supplier.supplierEmail
        }))
      }))
    };

   
  
    const Excel = await import('exceljs');
    const fileSaverMod = await import('file-saver');
    const saveAs = (fileSaverMod as any).saveAs || (fileSaverMod as any).default;
    const workbook = new Excel.Workbook();
    const ws = workbook.addWorksheet('RFQ');
  
    // === TITLE ===
    ws.mergeCells('A1:G1');
    const title = ws.getCell('A1');
    title.value = 'Request For Quotation';
    title.font = { size: 18, bold: true, color: { argb: '1F4E78' } };
    title.alignment = { horizontal: 'center', vertical: 'middle' };
    ws.addRow([]);
  
    // === RFQ DETAILS HEADER ===
    const rfqHeader = ws.addRow(['RFQ DETAILS']);
    rfqHeader.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'D9E1F2' } };
    rfqHeader.getCell(1).font = { bold: true };
    ws.addRow([]);
  
    // RFQ Info
    const rfqInfo = [
      ['RFQ Ref:', data.rfqRef, '', '', '', 'RFQ Date:', data.rfqDate],
      ['Preferred Currency:', data.preferredCurrency, '', '', '', 'Vessel Name:', data.vesselName],
      ['IMO Number:', data.imoNumber, '', '', '', 'Quote By Date:', data.quoteByDate],
      ['Requested Delivery Date:', data.requestedDeliveryDate],
    ];
    rfqInfo.forEach(r => {
      const row = ws.addRow(r);
      row.eachCell(c => (c.alignment = { vertical: 'middle' }));
    });
    ws.addRow([]);
  
    // === BUYER DETAILS ===
    const buyerHeader = ws.addRow(['Buyer Details']);
    buyerHeader.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF2CC' } };
    buyerHeader.getCell(1).font = { bold: true };
    ws.addRow([]);
    const buyer = [
      ['Name', data.buyerDetails.name],
      ['Address', data.buyerDetails.address],
      ['Contact', data.buyerDetails.contact],
      ['Phone', data.buyerDetails.phone],
      ['Email', data.buyerDetails.email],
    ];
    buyer.forEach(r => ws.addRow(r));
    ws.addRow([]);
  
    // === FREIGHT FORWARDER + PORT AGENT ===
    const faHeader = ws.addRow(['Freight Forwarder Details', '', '', 'Port Agent Details']);
    faHeader.eachCell(c => {
      c.font = { bold: true };
      c.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'E2EFDA' } };
    });
    ws.addRow([]);
    // const maxRows = Math.max(
    //   Object.keys(data.freightForwarderDetails).length,
    //   Object.keys(data.portAgentDetails).length
    // );
    // const ffd = Object.entries(data.freightForwarderDetails);
    // const pad = Array(maxRows - ffd.length).fill(['', '']);
    // const pad2 = Array(maxRows - Object.entries(data.portAgentDetails).length).fill(['', '']);
    // const padData = ffd.concat(pad);
    // const padAgent = Object.entries(data.portAgentDetails).concat(pad2);
  
    // for (let i = 0; i < maxRows; i++) {
    //   ws.addRow([
    //     padData[i][0],
    //     padData[i][1],
    //     '',
    //     padAgent[i][0],
    //     padAgent[i][1],
    //   ]);
    // }
  
    const freightEntries = Object.entries(data.freightForwarderDetails).map(([key, value]) => [
      labelMap[key] || key.replace(/([A-Z])/g, ' $1').replace(/^./, s => s.toUpperCase()),
      value
    ]);
    
    const portAgentEntries = Object.entries(data.portAgentDetails || {}).map(([key, value]) => [
      labelMap[key] || key.replace(/([A-Z])/g, ' $1').replace(/^./, s => s.toUpperCase()),
      value
    ]);
    
    // Ensure equal number of rows for both sections
    const maxRows = Math.max(freightEntries.length, portAgentEntries.length);
    const paddedFreight = [...freightEntries, ...Array(maxRows - freightEntries.length).fill(['', ''])];
    const paddedPortAgent = [...portAgentEntries, ...Array(maxRows - portAgentEntries.length).fill(['', ''])];
    
    // Add rows to worksheet (no borders, clean formatting)
    for (let i = 0; i < maxRows; i++) {
      const row = ws.addRow([
        paddedFreight[i][0], paddedFreight[i][1],
        '',
        paddedPortAgent[i][0], paddedPortAgent[i][1]
      ]);
    
    
    }


    ws.addRow([]);
  
    // === PORT DETAILS ===
    const portHeader = ws.addRow(['Port Details']);
    portHeader.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FCE4D6' } };
    portHeader.getCell(1).font = { bold: true };
    ws.addRow([]);
    ws.addRow(['Port Name', data.portDetails.portName]);
    ws.addRow(['Vessel ETA', data.portDetails.vesselETA]);
    ws.addRow(['Vessel ETD', data.portDetails.vesselETD]);
    ws.addRow([]);
  
    // === LINE ITEMS ===
    const liHeader = ws.addRow(['Line Items']);
    liHeader.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'BDD7EE' } };
    liHeader.getCell(1).font = { bold: true };
    ws.addRow([]);
  
    const tableHeader = ws.addRow([
      'Sr. No',
      'Part Number',
      'Item Description',
      'Qty',
      'UOM',
      'Buyer Comments',
      'Attached Suppliers',
    ]);
    tableHeader.eachCell(cell => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'D9D9D9' } };
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    });
  

  
    data.lineItems.forEach((item: { attachedSuppliers: any[]; srNo: any; partNumber: any; itemDescription: any; qty: any; uom: any; buyerComments: any; }) => {
      const supplierNames = item.attachedSuppliers.map((s) => s.name).join('\n'); // multiline
  
      const row = ws.addRow([
        item.srNo,
        item.partNumber,
        item.itemDescription,
        item.qty,
        item.uom,
        item.buyerComments,
        supplierNames,
      ]);
  
      row.eachCell((cell) => {
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
        cell.alignment = { wrapText: true, vertical: 'middle' };
      });
    });
    

    ws.addRow([]);  

    // VSMPS Buyer and Supplier section
    ws.addRow([`From VSMPS Buyer: ${data.buyerDetails.mpsBuyerCode}`]);
    ws.addRow([data.buyerDetails.name]);
    ws.addRow([data.buyerDetails.address]);

    ws.addRow([]);
    ws.addRow(['Copyright © Varuna Sentinels BV. All rights reserved.']);
    // ws?.lastRow?.getCell(1).alignment = { horizontal: 'left' };
    // ws.lastRow?.getCell(1).font = { italic: true, size: 9, color: { argb: '808080' } };
  
    // === AUTO WIDTH ===
    const colCount = ws.actualColumnCount;
    for (let i = 1; i <= colCount; i++) {
      let maxLen = 12;
      ws.eachRow({ includeEmpty: true }, (r) => {
        const val = r.getCell(i).value;
        const len = val ? val.toString().length : 0;
        if (len > maxLen) maxLen = len;
      });
      ws.getColumn(i).width = Math.min(maxLen + 4, 40);
    }
  
    workbook.xlsx.writeBuffer().then(buffer => {
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      saveAs(blob, fileName);
    });


    this.fullLoaderService.hideLoader()

  }

  async generateQuoteExcel(quoteId:number,rfqId: number, supplierId:number, ref:string) {

    this.fullLoaderService.showLoader()
  
    let fileName = ref +'.xlsx';
    
    let params = {
      supplierId: Number(supplierId),
      rfqId: Number(rfqId),
      quoteId:Number(quoteId)
    }
    const result = await this.SettingsService.fetchQuoteAttachmentExcelData(params)

    
    console.log(result,'result')
  
  
    const data = {
      quoteDetails:{
        quoteRef:result.quoteData.quoteRefNumber,
        quotedDate:result.quoteData.quotationDate,
        pricesGoodUntil:result.quoteData.pricesGoodUntil,
        offeredQuality: result.quoteData.offeredQualityName,
        currency:result.quoteData.currencyCode,
        onTimeDeliveryOrderBy:result.quoteData.onTimeDeliveryOrderBy,
        quotedDeliveryInDays: result.quoteData.quotedDeliveryInDays,
        incoterms: result.quoteData.incotermsName,
        incotermsLocation: result.quoteData.incotermLocations,
        paymentTerms:result.quoteData.paymentTermsCondition,
        termsAndCondition:this.convertHtmlToPlainText(result.quoteData.termsAndConditions)
      },
      rfqDetails:{
        rfqRef: result.quoteData.rfqRefNumber,
        vesselName: result.quoteData.vesselName,
        imoNumber: result.quoteData.vesselImoNumber,
        hullNumber: result.quoteData.hullNumber,
        yardName: result.quoteData.yardName,
        yearBuilt:result.quoteData.yearBuilt,
        requestedDeliveryDate: result.quoteData.requestDeliveryDate,
      },
      
      buyerDetails: {  
        name: result.quoteData.buyerCompanyName,
        address: result.quoteData.buyerCompanyAddress,
        contact: result.quoteData.buyerContact,
        phone: result.quoteData.buyerCompanyPhone,
        email: result.quoteData.buyerCompanyEmail,
        mpsBuyerCode: result.quoteData.buyerMpsCode,
      },
      supplierDetails: {
        name: result.quoteData.supplierCompanyName,
        address: `${result.quoteData.supplierStreet}, ${result.quoteData.supplierCity}, ${result.quoteData.supplierCountry}, ${result.quoteData.supplierZipcode}`,
        contact: result.quoteData.supplierContact,
        phone: result.quoteData.supplierPhone,
        email: result.quoteData.supplierEmail,
        mpsSupplierCode: result.quoteData.supplierMpsCode,
      },
      freightForwarderDetails: {
        PIC: result.quoteData.qffpic,
        phone: result.quoteData.qffphone,
        fax: result.quoteData.qfffax,
        email: result.quoteData.qffemailId,
        address: result.quoteData.qffaddress,
      },
     
      portDetails: {
        portName: result.quoteData.portName,
        vesselETA: result.quoteData.vesselEta,
        vesselETD: result.quoteData.vesselEtd,
      },
      costSummary:{
        lineItemSubtotal:parseFloat(result.quoteData.lineItemSubtotal || 0).toFixed(3),
        generalDiscountType: result.quoteData.generalDiscountType || 'percentage',
        generalDiscountValue: parseFloat(result.quoteData.generalDiscountValue || 0),
        generalDiscountAmount: (result.quoteData.generalDiscountType || 'percentage') === 'percentage'
          ? (parseFloat(result.quoteData.lineItemSubtotal || 0) * parseFloat(result.quoteData.generalDiscountValue || 0) / 100).toFixed(3)
          : parseFloat(result.quoteData.generalDiscountValue || 0).toFixed(3),
        taxAmount: parseFloat(result.quoteData.taxAmount || 0).toFixed(3),
        otherCharges:result.quoteData.quoteLineItemFreight,
        totalAdditionalCOst:parseFloat(result.quoteData.freightValue || 0).toFixed(3),
        currency:result.quoteData.currencyCode,
        grandTotal: parseFloat(result.quoteData.subtotal || 0).toFixed(3)
      },
      lineItems: result.lineItemData.map((item: {
        partNo: any;
        supplierPartNo: any;
        description: any;
        supplierQuantity: any;
        unitOfMeasure: any;
        supplierUOM: any;
        unitCost: any;
        discountPercent: any;
        totalCost: any;
        leadTime: any;
        supplierComment: any; partNumber: any; itemDescription: any; quantity: any; uom: any; buyerComments: any; 
}, index: number) => ({
        srNo: index + 1,
        partNumber: item.partNo,
        supplierPartNumber: item.supplierPartNo,
        itemDescription: item.description,
        requestedQty: item.quantity,
        quotedQuantity: item.supplierQuantity,
        requestedUom: item.unitOfMeasure,
        quotedUom: item.supplierUOM,
        unitCost: item.unitCost,
        discount: item.discountPercent,
        totalCost: item.totalCost,
        leadDays: item.leadTime,
        supplierRemarks: item.supplierComment || ''
       
        
      }))
    };
  
    
  
    const Excel = await import('exceljs');
    const fileSaverMod = await import('file-saver');
    const saveAs = (fileSaverMod as any).saveAs || (fileSaverMod as any).default;
    const workbook = new Excel.Workbook();
    const ws = workbook.addWorksheet('Quotation');

    // === TITLE ===
    ws.mergeCells('A1:G1');
    const title = ws.getCell('A1');
    title.value = 'Quotation';
    title.font = { size: 18, bold: true, color: { argb: '1F4E78' } };
    title.alignment = { horizontal: 'center', vertical: 'middle' };
    ws.addRow([]);

    // === QUOTATION DETAILS ===
    const quoteHeader = ws.addRow(['QUOTATION DETAILS']);
    quoteHeader.getCell(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'D9E1F2' },
    };
    quoteHeader.getCell(1).font = { bold: true };
    ws.addRow([]);

    // Quotation Info
    const quoteInfo = [
      [
        'Quote Ref:',
        data.quoteDetails.quoteRef,
        '',
        'On-Time Delivery Order By:',
        data.quoteDetails.onTimeDeliveryOrderBy,
      ],
      [
        'Quoted Date:',
        data.quoteDetails.quotedDate,
        '',
       
        'Quoted Delivery in Days:',
        data.quoteDetails.quotedDeliveryInDays,
      ],
      [
        'Prices Good Until:',
        data.quoteDetails.pricesGoodUntil,
        '',
        
        'Incoterms:',
        data.quoteDetails.incoterms,
      ],
      [
        'Offered Quality:',
        data.quoteDetails.offeredQuality,
        '',
        'Incoterms Location:',
        data.quoteDetails.incotermsLocation,
      ],
      [
        'Currency:',
        data.quoteDetails.currency,
        '',
        'Payment Terms:',
        data.quoteDetails.paymentTerms,
      ],
    ];
    quoteInfo.forEach((r) => {
      const row = ws.addRow(r);
      row.eachCell((c) => (c.alignment = { vertical: 'middle' }));
    });
    ws.addRow([]);

    // === BUYER AND SUPPLIER DETAILS ===
    const BsHeader = ws.addRow(['Buyer Details', '', '', 'Supplier Details']);
    BsHeader.eachCell(c => {
      c.font = { bold: true };
      c.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF2CC' } };
    });

    ws.addRow([]);

    // const BsmaxRows = Math.max(
    //   Object.keys(data.buyerDetails).length,
    //   Object.keys(data.supplierDetails).length
    // );

    // const bd = Object.entries(data.buyerDetails);
    // const bpad = Array(BsmaxRows - bd.length).fill(['', '']);
    // const bpad2 = Array(BsmaxRows - Object.entries(data.supplierDetails).length).fill(['', '']);
    // const bpadData = bd.concat(bpad);
    // const supp = Object.entries(data.supplierDetails).concat(bpad2);

    // for (let i = 0; i < BsmaxRows; i++) {
    //   ws.addRow([
    //     bpadData[i][0],
    //     bpadData[i][1],
    //     '',
    //     supp[i][0],
    //     supp[i][1],
    //   ]);
    // }
    const buyerEntries = Object.entries(data.buyerDetails).map(([key, value]) => [
      labelMap[key] || key.replace(/([A-Z])/g, ' $1').replace(/^./, s => s.toUpperCase()),
      value
    ]);
    
    const supplierEntries = Object.entries(data.supplierDetails).map(([key, value]) => [
      labelMap[key] || key.replace(/([A-Z])/g, ' $1').replace(/^./, s => s.toUpperCase()),
      value
    ]);
    
    // Pad so both arrays have the same length
    const maxRows = Math.max(buyerEntries.length, supplierEntries.length);
    const paddedBuyer = [...buyerEntries, ...Array(maxRows - buyerEntries.length).fill(['', ''])];
    const paddedSupplier = [...supplierEntries, ...Array(maxRows - supplierEntries.length).fill(['', ''])];
    
  
    for (let i = 0; i < maxRows; i++) {
      const row = ws.addRow([
        paddedBuyer[i][0], paddedBuyer[i][1],
        '',
        paddedSupplier[i][0], paddedSupplier[i][1]
      ]);
    
    
      row.eachCell(cell => {
        cell.alignment = { vertical: 'middle', wrapText: true };
      });
    }
    




    ws.addRow([]);


    const rfqHeader = ws.addRow(['RFQ Details']);
    rfqHeader.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'f9bccb' } };
    rfqHeader.getCell(1).font = { bold: true };
    ws.addRow([]);
    ws.addRow(['Vessel Name', data.rfqDetails.vesselName]);
    ws.addRow(['Vessel IMO', data.rfqDetails.imoNumber]);
    ws.addRow(['Hull Number', data.rfqDetails.hullNumber]);
    ws.addRow(['Yard Name', data.rfqDetails.yardName]);
    ws.addRow(['Build Year', data.rfqDetails.yearBuilt]);
    ws.addRow(['Vessel ETA', data.portDetails.vesselETA]);
    ws.addRow(['Vessel ETA', data.portDetails.vesselETD]);
    ws.addRow([]);
    ws.addRow([]);


    const freightHeader = ws.addRow(['Freight Details']);
    freightHeader.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FCE4D6' } };
    freightHeader.getCell(1).font = { bold: true };
    ws.addRow([]);
    ws.addRow(['PIC', data.freightForwarderDetails.PIC]);
    ws.addRow(['Phone', data.freightForwarderDetails.phone]);
    ws.addRow(['Fax', data.freightForwarderDetails.fax]);
    ws.addRow(['Email', data.freightForwarderDetails.email]);
    ws.addRow(['Address', data.freightForwarderDetails.address]);
    ws.addRow([]);
    ws.addRow([]);

  
    // === LINE ITEMS ===
    const liHeader = ws.addRow(['Line Items']);
    liHeader.getCell(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'BDD7EE' },
    };
    liHeader.getCell(1).font = { bold: true };
    ws.addRow([]);

    const tableHeader = ws.addRow([
      'Sr. No',
      'Part Number',
      'Supplier Part Number',
      'Item Description',
      'Requested Qty',
      'Quoted Qty',
      'Requested UOM',
      'Quoted UOM',
      'Unit Cost',
      'Discount',
      'Total Cost' ,
      'Lead Days',
      'Supplier Remarks'
    ]);
    tableHeader.eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'D9D9D9' },
      };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });

    // Add Line Items
    data.lineItems.forEach((item: {
      supplierRemarks: any; srNo: any; partNumber: any; supplierPartNumber: any; itemDescription: any; requestedQty: any; quotedQuantity: any; requestedUom: any; quotedUom: any; unitCost: any; discount: any; totalCost: any; leadDays: any; supplierComment: any; 
}) => {
      const row = ws.addRow([
        item.srNo,
        item.partNumber,
        item.supplierPartNumber,
        item.itemDescription,
        item.requestedQty,
        item.quotedQuantity,
        item.requestedUom,
        item.quotedUom,
        item.unitCost,
        item.discount,
        item.totalCost,
        item.leadDays,
        item.supplierRemarks

      ]);
      row.eachCell((cell) => {
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
        cell.alignment = { wrapText: true, vertical: 'middle' };
      });
    });

    ws.addRow([]);



    const costSummaryHeader = ws.addRow(['Cost Summary']);
    costSummaryHeader.getCell(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'F9F9F9' },
    };
    costSummaryHeader.getCell(1).font = { bold: true };
    ws.addRow([]);

    // Cost Summary Table
    const costSummaryTableHeader = ws.addRow(['Description', 'Amount']);
    costSummaryTableHeader.eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'D9D9D9' },
      };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });

    // Line Total Amount
    const lineTotalRow = ws.addRow([
      'Line Total Amount',
      data.costSummary.lineItemSubtotal,
    ]);
    lineTotalRow.eachCell((cell) => {
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });

    // General Discount Amount (only if > 0)
    if (parseFloat(data.costSummary.generalDiscountAmount) > 0) {
      const generalDiscountRow = ws.addRow([
        'General Discount Amount',
        `${data.costSummary.generalDiscountAmount}`,
      ]);
      generalDiscountRow.eachCell((cell) => {
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
      });
    }

    // Adding Additional Charges 
    let totalAdditionalCharges = 0;
    data.costSummary.otherCharges.forEach((charge: { freightDescription: any; freightValue: number; }) => {
      const row = ws.addRow([charge.freightDescription, charge.freightValue]);
      row.eachCell((cell) => {
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
      });
      totalAdditionalCharges += charge.freightValue;
    });

    // Total Additional Cost
    const totalAdditionalCostRow = ws.addRow([
      'Total Additional Cost',
      totalAdditionalCharges,
    ]);
    totalAdditionalCostRow.eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });

    // Tax Amount (only if > 0)
    if (parseFloat(data.costSummary.taxAmount) > 0) {
      const taxAmountRow = ws.addRow([
        'Tax Amount',
        data.costSummary.taxAmount,
      ]);
      taxAmountRow.eachCell((cell) => {
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
      });
    }

    // Grand Total
    const grandTotalRow = ws.addRow([
      'Grand Total',
      `${data.costSummary.grandTotal} ${data.costSummary.currency}`,
    ]);
    grandTotalRow.eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });

    ws.addRow([]);

    const termsHeader = ws.addRow(['Terms And Conditions']);
    termsHeader.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FCE4D6' } };
    termsHeader.getCell(1).font = { bold: true };
    ws.addRow([]);
    ws.addRow([data.quoteDetails.termsAndCondition]);
    ws.addRow([]);
    ws.addRow([]);


    // === VSMPS Buyer and Supplier section ===
    ws.addRow([`From VSMPS Supplier: ${data.supplierDetails.mpsSupplierCode}`]);
    ws.addRow([data.supplierDetails.name]);
    ws.addRow([data.supplierDetails.address]);

    ws.addRow([]);

    ws.addRow([`To VSMPS Buyer: ${data.buyerDetails.mpsBuyerCode}`]);
    ws.addRow([data.buyerDetails.name]);
    ws.addRow([data.buyerDetails.address]);

    ws.addRow([]);


    ws.addRow(['Copyright © Varuna Sentinels BV. All rights reserved.']);

    // === AUTO WIDTH ===
    const colCount = ws.actualColumnCount;
    for (let i = 1; i <= colCount; i++) {
      let maxLen = 12;
      ws.eachRow({ includeEmpty: true }, (r) => {
        const val = r.getCell(i).value;
        const len = val ? val.toString().length : 0;
        if (len > maxLen) maxLen = len;
      });
      ws.getColumn(i).width = Math.min(maxLen + 4, 40);
    }
  
    workbook.xlsx.writeBuffer().then(buffer => {
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      saveAs(blob, fileName);
    });
  
  
    this.fullLoaderService.hideLoader()
  
  }

  convertHtmlToPlainText(html: string): string {
    if (!html) return '';

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;

    // Replace <li> with line breaks + bullet
    tempDiv.querySelectorAll('li').forEach(li => {
      li.insertAdjacentText('beforebegin', '\n• ');
    });

    // Replace <br> and block tags with line breaks
    const blockTags = ['p', 'div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'ul', 'ol'];
    blockTags.forEach(tag => {
      tempDiv.querySelectorAll(tag).forEach(el => {
        el.insertAdjacentText('beforebegin', '\n');
      });
    });

    const text = tempDiv.textContent || '';
    return text.replace(/\n{2,}/g, '\n').trim(); // Remove extra empty lines
  }

  // toggleExpandedRow(row: any) {
  //   this.expandedRowId = this.expandedRowId === row.id ? null : row.id;
  // }

  toggleQuoteTypeDropdown() {
    this.quoteTypeDropdownOpen = !this.quoteTypeDropdownOpen;
  }

  navigateToQuoteType(type: string) {
    if (type === 'product') {
      this.router.navigate(['/operations/buyer-quote-list']);
    } else if (type === 'service') {
      this.router.navigate(['/operations/buyer-service-quote-list']);
    }
  }

}







